module.exports = {"appId":"fulfillment","appUrl":"scanshipco.com","appVersion":"api","useSSL":true,"currentVersion":""}


//////////////////
// WEBPACK FOOTER
// ./src/config/production/application-settings.json
// module id = 3075
// module chunks = 1